<template>
  <div class="card">
    <div class="card-section" v-if="!editMode">
      <div class="bracket-value">
        {{ formatMoney(bracket.ticketValue) }}
      </div>
      <div class="bracket-tickets">
        {{ bracket.backers }} de {{ bracket.availableTickets }}
      </div>
      <div class="benefits">
        {{ bracket.description }}
      </div>
      <div class="actions">
        <div class="action" @click="editMode = true">Editar</div>
        <div class="action" @click="deleteBracket">Eliminar</div>
      </div>
    </div>
    <div class="card-section" v-else>
      <div class="bracket-value">
        Editar bracket
      </div>
      <div class="label">Inversión (centavos):</div>
      <BaseInput class="numbers-input" v-model="data.ticketValue" />
      <div class="label">Disponibles:</div>
      <BaseInput class="numbers-input" v-model="data.availableTickets" />
      <div class="label">Reservados:</div>
      <BaseInput class="numbers-input" v-model="data.backers" />
      <div class="label">Descripción:</div>
      <BaseInput v-model="data.description" />
      <div class="button" @click="saveBracket">
        Guardar
      </div>
    </div>
  </div>
</template>

<script>
import formatMixin from '@/mixins/formatMixin';
import BaseInput from '@/components/base/BaseInput.vue';
import { createNamespacedHelpers } from 'vuex';

const { mapActions } = createNamespacedHelpers('admin');

export default {
  data() {
    return {
      editMode: false,
      data: {
        ticketValue: 0,
        description: '',
        availableTickets: 0,
        backers: 0,
      },
    };
  },
  components: {
    BaseInput,
  },
  props: {
    bracket: Object,
  },
  mixins: [formatMixin],
  methods: {
    async saveBracket() {
      console.log(this.bracket.id);
      await this.editBracket({
        data: this.data,
        projectId: parseInt(this.$route.params.id, 10),
        bracketId: this.bracket.id,
      });
      this.editMode = false;
    },
    async deleteBracket() {
      await this.removeBracket({
        projectId: parseInt(this.$route.params.id, 10),
        bracketId: this.bracket.id,
      });
    },
    ...mapActions([
      'editBracket',
      'removeBracket',
    ]),
  },
  mounted() {
    Object.keys(this.data).forEach((key) => {
      this.data[key] = this.bracket[key];
    });
  },
};
</script>

<style lang="scss" scoped>
.card {
  border: 1px solid #e8e8e8;
  background-color: white;
  padding: 20px;
  border-radius: 6px;
  margin-top: 24px;
  width: 46%;
  display: flex;
  flex-wrap: wrap;
}
.bracket-value {
  font-weight: bold;
  font-size: 28px;
  margin-bottom: 10px;
}
.benefits {
  line-height: 20px;
}
.bracket-tickets {
  width: 100%;
  color: gray;
  margin-bottom: 14px;
}
.actions {
  width: 100%;
  display: flex;
  margin-top: 20px;
}
.action {
  margin-right: 20px;
  color: #3479e9;
  cursor: pointer;
}
.card-section {
  width: 100%;
}
.label {
  margin-top: 18px;
  margin-bottom: 12px;
}
.numbers-input {
  width: 65%;
}
.button {
  background-color: #3479e9;
  color: white;
  padding: 12px 20px;
  display: flex;
  font-size: 16px;
  border-radius: 4px;
  cursor: pointer;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
}
</style>
